<template>
    <div
        :class="disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'"
        class="flex items-center justify-between gap-1 rounded-lg border-1 border-gray-200 px-6 py-1"
        @click.stop="toggleStep"
    >
        <div v-html="label" />
        <div class="flex items-center gap-1">
            <div :class="{ 'cursor-pointer': !disabled }" @click.stop="confirmStep">
                <check-circle-icon :active="checked === true" class="h-10 w-10" />
            </div>
            <div :class="{ 'cursor-pointer': !disabled }" @click.stop="rejectStep">
                <x-circle-icon :active="checked === false" class="h-10 w-10" />
            </div>
        </div>
    </div>
</template>
<script setup>
import CheckCircleIcon from '@/Components/Icons/CheckCircleIcon.vue';
import XCircleIcon from '@/Components/Icons/XCircleIcon.vue';

const props = defineProps({
    label: String,
    disabled: Boolean,
    checked: Boolean,
});

const emit = defineEmits(['change']);

const confirmStep = () => {
    if (props.disabled) return;
    emit('change', true);
};

const rejectStep = () => {
    if (props.disabled) return;
    emit('change', false);
};

const toggleStep = () => {
    if (props.disabled) return;
    emit('change', !props.checked);
};
</script>
